import { EPageComponentTypes, ERouteLinks, IPageBuilderConfig } from 'models/route';

export const config: IPageBuilderConfig[] = [
  {
    componentType: EPageComponentTypes.AuthPage,
    route: ERouteLinks.Auth,
    isProtected: false,
  },
  {
    componentType: EPageComponentTypes.ForgotPasswordPage,
    route: ERouteLinks.ForgotPassword,
    isProtected: false,
  },
  {
    componentType: EPageComponentTypes.ResetPasswordPage,
    route: ERouteLinks.ResetPasswordLink,
    isProtected: false,
  },
  {
    componentType: EPageComponentTypes.DashboardPage,
    route: ERouteLinks.Dashboard,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.NotFoundPage,
    route: ERouteLinks.NotFound,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.AccessDeniedPage,
    route: ERouteLinks.AccessDenied,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.ServerErrorPage,
    route: ERouteLinks.ServerError,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.MyApplicationsPage,
    route: ERouteLinks.MyApplications,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.ApplyOnlinePage,
    route: ERouteLinks.ApplyOnline,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.ApplyOnlineWizardPage,
    route: ERouteLinks.ApplyOnlineWizard,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.MyProfile,
    route: ERouteLinks.MyProfile,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.EditAccountData,
    route: ERouteLinks.EditAccountData,
    isProtected: true,
  },
  {
    componentType: EPageComponentTypes.ApplicationDetails,
    route: ERouteLinks.ApplicationDetails,
    isProtected: true,
  },
];
